import { useCallback } from 'react';
import { matchPath } from 'react-router-dom';
import { BASE_FORM_ROUTE_PATH } from '../config/routes';
import { FEATURE_FLAGS, useConfigMatch } from '../modules/taboola-common-frontend-modules/account-configurations';
import { useDrawerStack } from './queryParams/useDrawerStack';
import { useHistoryNavigate } from './useHistoryNavigate';

const hasFormMode = path =>
    matchPath(path, {
        path: BASE_FORM_ROUTE_PATH,
        exact: false,
        strict: false,
    }) !== null;

export const useNavigate = () => {
    const { push } = useDrawerStack();
    const historyNavigate = useHistoryNavigate();
    const isMultiLayerDrawerEnabled = useConfigMatch({ [FEATURE_FLAGS.MULTI_LAYER_DRAWER_ENABLED]: 'true' });

    const navigate = useCallback(
        path => {
            if (isMultiLayerDrawerEnabled && hasFormMode(path)) {
                push({ path });
                return;
            }

            historyNavigate(path);
        },
        [isMultiLayerDrawerEnabled, historyNavigate, push]
    );

    return navigate;
};
